import { BaseDialog } from "@/lib/Components/Dialog/BaseDialog";
import { GenericForm } from "@/lib/Components/Form/Forms/GenericForm";
import { useGqlMutation } from "@/lib/GraphQLCodegen/fetcher";
import { assignSalesAgentMutation } from "@/app/Organisations/GraphQL/organisationMutations.graphql";
import { useDialogState } from "@/lib/Components/Dialog/Hooks/useDialogState";
import { CreateSalesOrganisationAttributionInput } from "@/gql/graphql";
import { AllUserInput } from "@/app/Users/Components/AllUserInput";
import { DialogSubmitButton } from "@/lib/Components/Dialog/Components/DialogSubmitButton";

export function AssignOrganisationSalesAgentDialog({
  organisationId,
  userId,
  subtitle,
}: {
  organisationId: string;
  userId?: string | null;
  subtitle?: string;
}) {
  const { mutateAsync: assignSalesAgent } = useGqlMutation(
    assignSalesAgentMutation,
  );
  const { close } = useDialogState();

  return (
    <BaseDialog title="Assign Sales Agent" subtitle={subtitle}>
      <GenericForm<CreateSalesOrganisationAttributionInput>
        initialValues={{
          organisation: {
            connect: organisationId,
          },
          user: {
            connect: userId ?? null!,
          },
        }}
        onSubmit={async (values) => {
          await assignSalesAgent({
            input: values,
          });

          close();
        }}
      >
        <AllUserInput label="User" name="user.connect" />
        <DialogSubmitButton text="Assign" />
      </GenericForm>
    </BaseDialog>
  );
}
